import React from 'react';
import cx from 'classnames';
import Paragraph from './UI/Paragraph';
import StatBoxProps from '../types/StatBoxType';
import Title from './UI/Title';
import style from './StatBox.module.css';

/**
 * ## Display a box with stats
 *
 * @param {title} string - the title of the box
 * @param {children} string - the text to display
 * @returns React.ReactNode
 */
function StatBox({ title, children }: StatBoxProps) {
  return (
    <div data-testid="statBox" className={cx(style.statsBox, style.withMargin)}>
      <Title level={3} css="position-relative" data-testid="title">
        {title}
      </Title>
      <Paragraph
        css="m-0 position-relative text-uppercase"
        data-testid="paragraph"
        translationId={children}
      />
    </div>
  );
}

export default StatBox;
